import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { authSliceActions } from '@Store/slices/authSlice';
import { getAuthConfig } from '@Utils/getApiUrl';
import { useAppDispatch } from '.';

const useAuthRenewal = (): void => {
  const { instance, accounts } = useMsal();
  const CHECK_INTERVAL = 5 * 60 * 1000;
  const dispatch = useAppDispatch();
  const { azureScopes } = getAuthConfig();

  useEffect(() => {
    const request = {
      scopes: azureScopes,
      account: accounts[0],
    };

    const refreshToken = async (): Promise<void> => {
      try {
        const tokenResponse = await instance.acquireTokenSilent(request);
        const sessionTokenJSONKey = `${tokenResponse.account.homeAccountId}-${tokenResponse.account.environment}-accesstoken-${tokenResponse.account.idTokenClaims?.aud}-${tokenResponse.tenantId}-${tokenResponse.scopes.join(' ')}--`;

        dispatch(authSliceActions.setJSONKey(sessionTokenJSONKey));
        dispatch(authSliceActions.setAuthToken(tokenResponse.accessToken));
      } catch (error) {
        console.error('Token refresh failed: ', error);
      }
    };

    const renewalTimeId = setInterval(refreshToken, CHECK_INTERVAL);

    return () => clearInterval(renewalTimeId);
  }, [instance, accounts]);
};

export default useAuthRenewal;
